import React, {useEffect, useState} from 'react'

import api from '../../_services/api'
import { useNavigate, useParams } from 'react-router'
import { useApp } from "contexts/AppContext";
import { checkoutHotelAction, clearSearch } from "contexts/reducers/hotels/actions";
import { checkoutCarAction, clearSearchCar } from "contexts/reducers/cars/actions";
import { useUserData } from '../../hooks/UserContext'

import { formatCurrency  } from 'utils/functions'

import {Row, Col, Button, Form} from 'react-bootstrap'
import { Box } from './styles'
import notify from "components/UI/toast";
import {LoaderSmall} from 'components/Loader';
import CreditCardList from "components/CreditCardList";
import { ResumeCar, ResumeHotel } from 'components/Resume';
import { SliderCheckout } from 'components/SliderCheckout';
import { getInstallments } from 'components/Installments/services/InstallmentsService'

export function CheckoutTravel() {

    const navigate = useNavigate()
    const { product } = useParams()
    const { user } = useUserData()
    const { hotelState, hotelDispatch, carState, carDispatch } = useApp()

    const { hotel, room, travellers, datesSearchHotel, offersHotel } = hotelState;
    const { car, conductor, offersCar } = carState;

    const [totalPayment, setTotalPayment] = useState({
        points: 0,
        cash: product === 'car'
            ? car.fareSummary.originalDisplayTotalAmount
            : (room.amount.BRL * datesSearchHotel.days) + room?.dailyTax?.value
    })

    const totalPurchase = product === 'car'
        ? car.fareSummary.originalDisplayTotalAmount / 100
        : (room.amount.BRL * datesSearchHotel.days) + room?.dailyTax?.value


    const [loading, setLoading] = useState(true);
    const [loadingCheckout, setLoadingCheckout] = useState(false);
    const [activeSlider, setActiveSlider] = useState(false)

    const [boxNewCard, setBoxNewCard] = useState(false);

    const [cards, setCards] = useState([]);
    const [cardHashSelected, setCardHashSelected] = useState();

    const [installmentsSelected, setInstallmentsSelected] = useState();
    const [installments, setInstallments] = useState([]);

    const [disableMoneyPayment, setDisableMoneyPayment] = useState('');
    const [refreshCards, setRefreshCards] = useState();

    function changeTotal(values) {
        setTotalPayment(values)
        cardHashSelected && changeInstallment(cardHashSelected, null, values.cash)
    }

    useEffect(() => {

        if (product === 'hotel' && offersHotel === 'points') {
            setActiveSlider(true)
        }

        if (product === 'car' && offersCar === 'points') {
            setActiveSlider(true)
        }

    }, [])

    async function getCard() {
        try {
            const response = await api.get('/api/list-card?customerUuid=' + user?.uuid)
            return response.data.data
        } catch (err) {
            notify('Erro ao consultar informações.', 'error')
        }
    }

    useEffect(() => {

        // if (dataCheckout?.summary?.coupon) {
        //     lockSlider()
        // }
        typeof cardHashSelected !== 'undefined' && selecionarParcela(cardHashSelected)
        setInstallmentsSelected('')
        setInstallments([])
        totalPurchase === 0 ? setDisableMoneyPayment('disable') : setDisableMoneyPayment('')
    }, [ totalPurchase ]);


    useEffect(() => {
        const fetchData = async () => {

            const cardsUser = await getCard()

            const addHash = cardsUser?.map((card, index) => ({
                'lastFourDigits': card.last_four_digits,
                'expiration': card.expiration_month + '/' + card.expiration_year,
                'hash': card.uuid,
                'uuid': card.uuid,
                'save': false,
                'brand': card.brand
            }))
            setCards(addHash);

            setLoading(false)
        }

        if (user) fetchData()

    }, [user, refreshCards])


    const saveNewCard = (values, card_hash) => {
        const last_digits = values.card_number?.substr(-4);
        setCards([{
            lastFourDigits: last_digits,
            expiration: values.card_expiration_date,
            hash: card_hash,
            save: values.card_save
        }, ...cards]);
        if (values.card_save) {
            addApiCard(card_hash)
        }
    }

    async function changeInstallment(card_hash, last_digits = null, newValue = null) {
        setCardHashSelected(card_hash)
        let cartao = cards.find(card => card.hash === card_hash)
        last_digits = cartao?.lastFourDigits || last_digits
        let valorTotal = newValue ?? totalPayment.cash
      //  valorTotal = valorTotal /100
        if (last_digits) {
            const result = await getInstallments(user.uuid, valorTotal, last_digits, null, 'wl')
            setInstallments(Object.values(result.data))
        }
    }

    async function addApiCard(hashCard) {
        try {
            const cardDetail =
                {
                    "customerUuid": user?.uuid,
                    "gatewayCardKey": hashCard
                }
            await api.post('/api/add-card', cardDetail);
            notify('Cartão atualizado com sucesso', 'success')
            return '#'
        } catch (err) {
            console.log(err)
            notify('Erro ao atualizar lista de cartões.', 'error')
        }
    }

    async function handleCheckout() {
        if (totalPurchase > 0) {
            if (!cardHashSelected) return notify('Informe o cartão para o pagamento.', 'error')
            if (!installmentsSelected) return notify('Selecione a quantidade de parcelas.', 'error')
        }

        let checkout;
        setLoadingCheckout(true);

        try {
            product === 'hotel'
                ? checkout = await checkoutHotelAction({ user, hotel, room, cardHashSelected, totalPayment, installmentsSelected, travellers })
                : checkout = await checkoutCarAction({ user, car, cardHashSelected, totalPayment, installmentsSelected, conductor })

            if (checkout.status === 201) {

                product === 'hotel' && hotelDispatch(clearSearch())
                product === 'car' && carDispatch(clearSearchCar())


                let order_uuid = checkout.data.data.order_uuid
                order_uuid = order_uuid.substr(-8)

                const installmentValue = (totalPayment.cash / installmentsSelected);

                window.location = "llwl://redeem?" +
                    "id=" + order_uuid +
                    "&partnerId=" + user.external_id +
                    "&value=" + totalPayment.cash +
                    "&installmentNumber=" + installmentsSelected +
                    "&installmentValue=" + installmentValue +
                    "&installmentTotal=" + totalPayment.cash +
                    "&customerId=" + user.uuid +
                    "&type=viagens"

               // navigate('/loja/checkout-message-travel/'+order_uuid)
            } else {
                navigate('/loja/checkout-message-travel')
            }

            setLoadingCheckout(false);
        } catch (e) {
            console.log('error checkout', e)
            setLoadingCheckout(false);
            navigate('/loja/checkout-message-travel')
        }
    }

    if (loadingCheckout) return <LoaderSmall/>
    if (loading) return <LoaderSmall/>

    return (
        <div className="wl-page">
            <div className="px-3">
                <p className="label-head fs-6 mt-5">
                    Resumo da reserva
                </p>
                { product === 'car' && <ResumeCar/> }
                { product === 'hotel' && <ResumeHotel/> }
            </div>

            { activeSlider &&
                <Box>
                    <p className="color-text-dark font-wl-600 p-3 mb-0 text-mlg">
                        Formas de pagamento
                    </p>
                    <div className="slider">
                        <SliderCheckout
                            changeTotal={changeTotal}
                            totalPurchase={product === 'hotel' ? room.amount.BRL : totalPurchase}
                            product={product}
                            daily={datesSearchHotel?.days}
                        />
                    </div>
                </Box>
            }

            <div className="px-3">
                <Row className="my-4">
                    <Col>
                        <Form.Group className="">
                            <CreditCardList
                                cards={cards}
                                openNewCard={() => setBoxNewCard(true)}
                                title="Formas de pagamento"
                                onSelected={(value) => changeInstallment(value)}
                                onSaveCard={(values, card_hash) =>
                                    saveNewCard(values, card_hash)
                                }
                                onRefreshCards={() => setRefreshCards(new Date())}
                            />
                        </Form.Group>
                    </Col>
                </Row>

                <Row>
                    <Col>
                        <Form.Group>
                            <p className="label-head font-wl-600 text-mlg my-3">
                                Parcelamento
                            </p>
                            <select
                                placeholder="Selecione as parcelas"
                                onChange={(e) => setInstallmentsSelected(e.target.value)}
                                disabled={false}
                                className="form-select form-select-custom border-custom"
                                style={{ lineHeight: "50px"}}
                            >
                                <option value="">Selecione as parcelas</option>
                                {installments.map((item, index) => (
                                    <option key={index} value={item.number}>
                                        {item.number} x{" "}
                                        {formatCurrency(item.installmentPrice)}
                                        {item.interest > 0
                                            ? ` (juros ${item.interest}%)`
                                            : "(sem juros)"}
                                    </option>
                                ))}
                            </select>
                        </Form.Group>
                    </Col>
                </Row>
            </div>
            <div className="px-3 my-5">
                <Button
                    type="button"
                    onClick={() => handleCheckout()}
                    className="btn-default-wl w-100"
                >
                    FINALIZAR O RESGATE
                </Button>
            </div>
        </div>
    );
}
